import { render, staticRenderFns } from "./FButton.vue?vue&type=template&id=7281a8ac&scoped=true"
import script from "./FButton.vue?vue&type=script&lang=ts"
export * from "./FButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7281a8ac",
  null
  
)

export default component.exports